<template lang="pug">
    div(
        v-if="resultCount > 0 || isActive"
        class="overflow-hidden"
        :class="[ isDisabled ? 'cursor-default' : 'cursor-pointer' ]"
    )
        div(
            @click="toggleFacet"
            class="pl-10 pr-3 font-bold py-3"
            :class="[headerClasses, isDisabled ? 'opacity-25' : '' ]"
        )
            div(class="flex justify-between items-center")
                | {{ sameDayShippingText }} Only

                div(
                    class="flex-none ml-2 my-2 h-4 w-8 flex items-center rounded-full border-2 border-gray"
                    :class="toggleColors"
                )
                    span(
                        class="h-3 w-3 bg-white rounded-full transform shadow"
                        :class="[ !isActive ? 'translate-x-0' : 'translate-x-4' ]"
                    )

        div(
            v-show="!isActive && !isDisabled"
            class="-mt-3 pl-10 pb-3 pr-3 text-sm"
        )
            p Only display items that ship the quickest

</template>

<script>
import SearchComponent from '@/components/search/component'
import { sameDayShippingDisplayMixin } from '@/helpers/shipping'

export default {
    name: 'SameDayShippingRefinement',
    extends: SearchComponent,
    mixins: [sameDayShippingDisplayMixin],
    computed: {
        resultCount() {
            return this.$searchContext.state.resultCount
        },
        isDisabled() {
            const refinements = this.$searchContext.state.refinements.sameDayShipping || []

            return !refinements.some(({ value }) => value === 'true')
        },
        isActive() {
            const { sameDayShipping } = this.$searchContext.state.activeRefinements

            return !!sameDayShipping
        },
        toggleColors() {
            if (this.isActive) {
                if (this.$sitewideData.config.sameDayShippingMode === 'RAPIDSHIP')
                    return 'bg-success-dark'

                return 'bg-info-dark'
            }

            return 'bg-gray-dark'
        },
        headerClasses() {
            const classes = []

            if (this.isActive) {
                classes.push('text-white', this.sameDayShippingBackgroundColor)
            } else {
                classes.push('bg-white text-dark')
            }

            return classes
        },
        hasFullFitment() {
            return this.$store.getters['fitment/hasFullFitment']
        },
    },
    methods: {
        toggleFacet() {
            if (this.isDisabled) {
                this.$notifications.addInfo(
                    `Oops, no ${this.sameDayShippingText} items available for that selection`,
                    `Don't worry! Just choose a different brand, category, or price range to see ${this.sameDayShippingText} items!`
                )
                return
            }

            const { sameDayShipping } = this.$searchContext.state.activeRefinements

            // If sameDayShipping exists in the activeRefinements then we are currently refined so we need to remove it.
            if (sameDayShipping) this.$searchContext.clearRefinements('sameDayShipping')
            // Since we adding the facet if we get to this else if,
            // If the user doesn't have full fitment, then we need to open the fitment modal instead of applying the facet and pushing the route.
            else if (!this.hasFullFitment) {
                this.$emit('onFitmentSelection')
                this.$store.dispatch('fitment/showFitmentModal', { isSameDayShippingMode: true })
                return
            }
            // Just add the facet because we are in a valid state to do so.
            else this.$searchContext.addRefinements('sameDayShipping', 'true')

            const { mod } = this.$route.query

            const routeObj = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...(mod && { mod }),
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$emit('refinementClicked', {
                attribute: 'sameDayShipping',
                title: 'Shipping',
                value: !!sameDayShipping,
            })

            this.$push.to(routeObj)
        },
    },
}
</script>
